import React from 'react';
import DashboardIntegrado from '../components/dashboard/DashboardIntegrado';

function Dashboard() {
  return <DashboardIntegrado />;
}

export default Dashboard;
